<template>
  <a-modal
    :visible="visible"
    :confirm-loading="loading"
    :footer="null"
    @cancel="handleCancel"
    :width="480"
    centered
    class="reject-modal"
    :maskClosable="false"
  >
    <template #title>
      <div class="modal-title">가입 거절</div>
    </template>

    <div class="modal-body">
      <div class="company-card" v-if="company">
        <span class="label">대상 업체</span>
        <h3 class="company-name">{{ company.name }}</h3>
      </div>

      <div class="form-section">
        <label class="form-label">
          거절 사유
          <span class="required-mark">*</span>
        </label>
        <a-textarea
          v-model:value="reason"
          placeholder="거절 사유를 상세히 입력해주세요."
          :rows="5"
          :maxlength="500"
          show-count
          class="custom-textarea"
        />
      </div>

      <div class="button-wrap">
        <a-button @click="handleCancel">취소</a-button>
        <a-button
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          class="yellow-button"
        >
          거절하기
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { message } from "ant-design-vue";

export default {
  name: "RejectReasonModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    company: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["cancel", "submit"],
  data() {
    return {
      reason: "",
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.reason = "";
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleSubmit() {
      if (!this.reason || this.reason.trim() === "") {
        message.warning("거절 사유를 입력해주세요.");
        return;
      }

      this.$emit("submit", this.reason.trim());
    },
  },
};
</script>

<style scoped lang="scss">
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #111;
}

.modal-body {
  padding: 8px 0;
}

.company-card {
  background-color: #f8f9fa;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    font-size: 12px;
    color: #718096;
    font-weight: 500;
  }

  .company-name {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #2d3748;
    line-height: 1.4;
  }
}

.form-section {
  margin-bottom: 8px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.required-mark {
  color: #ff4d4f;
  margin-left: 4px;
}

.custom-textarea {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 12px;
  font-size: 14px;
  line-height: 1.6;
  transition: all 0.2s;

  &:hover,
  &:focus {
    border-color: #ffcc32;
    box-shadow: 0 0 0 2px rgba(255, 204, 50, 0.1);
  }
}

// show-count 텍스트 스타일 조정
:deep(.ant-input-textarea-show-count::after) {
  margin-bottom: 0;
  color: #999;
  font-size: 12px;
}

.button-wrap {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.yellow-button {
  background-color: #ffc107 !important;
  border-color: #ffc107 !important;
  color: #000 !important;

  &:hover {
    background-color: #ffca2c !important;
    border-color: #ffc720 !important;
  }

  &:disabled {
    background-color: #f5f5f5 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}
</style>
